
export const errorUtils: {[key:number] : string } = {
  401: "sesión expirada",
  403: "No tiene autorización para realizar esta operación",
  404: "Página no encontrada" ,
  500: "Error inesperado"
}